export default {
  groupName: 'chick_fila',
  appName: 'QSR Category',
  baseRoute: '/dashboard/demo_ad_effect_restaurant',
  label: 'Demo - Ad Effect Restaurant',
  home: '/slicer',
  image: 'marketcast.png',
  description: 'Demo - Ad Effect Restaurant'
};



// WEBPACK FOOTER //
// ./src/app/configuration/ChickFilA/config/main.js